import React,{useState,useEffect,useRef,useMemo,useCallback} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import {FiX,FiPlay,FiCheck,FiStar,FiChevronDown,FiSearch,FiFilter} from 'react-icons/fi';
import './App.css';
import HeroSection from './components/HeroSection';
import WorkshopTimer from './components/WorkshopTimer';
import RegistrationForm from './components/RegistrationForm';
import {useWorkshopSchedule} from './hooks/useWorkshopSchedule';

// Video testimonials data
const testimonialVideos=[
  {id: 1,url: "https://www.youtube.com/watch?v=v3EEtDIaC3w",embedId: "v3EEtDIaC3w",thumbnail: "https://img.youtube.com/vi/v3EEtDIaC3w/maxresdefault.jpg",title: "எனது Sales Process-ஐ எப்படி Automate செய்தேன்?",name: "Business Coach"},
  {id: 2,url: "https://youtu.be/IrfPwkcSTB0?si=4zR7J5O2aIbdr7k0",embedId: "IrfPwkcSTB0",thumbnail: "https://img.youtube.com/vi/IrfPwkcSTB0/maxresdefault.jpg",title: "Autopilot-ல் Leads ஜெனரேட் செய்வது எப்படி?",name: "Marketing Consultant"},
  {id: 3,url: "https://youtu.be/F26JiMS-w4I?si=5CoJ4w0AnUAMPYZm",embedId: "F26JiMS-w4I",thumbnail: "https://img.youtube.com/vi/F26JiMS-w4I/maxresdefault.jpg",title: "Manual Follow-ups கஷ்டம் இனி இல்லை",name: "Agency Owner"},
  {id: 4,url: "https://youtu.be/yWzJt7jv5CM?si=cFmZMEoNQgvFxmh4",embedId: "yWzJt7jv5CM",thumbnail: "https://img.youtube.com/vi/yWzJt7jv5CM/maxresdefault.jpg",title: "தூங்கும் போதும் Sales நடக்கும் Magic",name: "Course Creator"},
  {id: 5,url: "https://youtu.be/fUCYE7BoTJo?si=vFUxnRuWJZE2zRKI",embedId: "fUCYE7BoTJo",thumbnail: "https://img.youtube.com/vi/fUCYE7BoTJo/maxresdefault.jpg",title: "WhatsApp Automation என் Business-ஐ மாற்றியது",name: "Trading Mentor"},
  {id: 6,url: "https://youtu.be/vRzrNK9XPmQ?si=LGC2-FHUQ0SlctTo",embedId: "vRzrNK9XPmQ",thumbnail: "https://img.youtube.com/vi/vRzrNK9XPmQ/maxresdefault.jpg",title: "Ads இல்லாமல் Consistent Leads",name: "Healthcare Professional"}
];

// Client Feedback data
const clientFeedbacks=[
  {id: 1,name: "A R Ahamed Junaith",role: "Spoken English Coach",image: "https://storage.files-vault.com/uploads/1760941910-ht57JBdJ4f.webp",quote: "எனது Lead Follow-up சிஸ்டமை முழுமையாக Automate செய்துவிட்டேன். WhatsApp Funnels மூலம் வெறும் 2 மாதங்களில் என் வருமானம் 3 மடங்கு (3X) அதிகரித்துள்ளது."},
  {id: 2,name: "Maria Sundar",role: "Stock Trader Coach",image: "https://storage.files-vault.com/uploads/1760942061-nsFEgCbsBd.webp",quote: "முன்பெல்லாம் நான் மணிக்கணக்கில் Calls பேசுவேன். இப்போது AI ஆரம்பகட்ட பேச்சுகளை பார்த்துக்கொள்கிறது,நான் Qualified Leads உடன் மட்டும் தான் பேசுகிறேன்."},
  {id: 3,name: "Arjumand",role: "Community Growth Expert",image: "https://storage.files-vault.com/uploads/1760942064-I6HBtoRq5t.webp",quote: "Ads-க்கு ஒரு ரூபாய் கூட செலவு இல்லை,வெறும் Organic WhatsApp Automation தான். ஒரே வாரத்தில் 60 Registrations மிக சுலபமாக கிடைத்தது."},
  {id: 4,name: "Subiya Fathima",role: "Bridal Leads Coach",image: "https://storage.files-vault.com/uploads/1760942062-cWbhjZc7n9.webp",quote: "ஒரு முறை System Set செய்தேன்,அது தொடர்ந்து Sales-ஐ கொண்டு வருகிறது. அவர்கள் சொன்னது போலவே இது உண்மையில் 'Sales on Autopilot' தான்."},
  {id: 5,name: "Manigandan",role: "FiveStar",image: "https://storage.files-vault.com/uploads/1760942066-tiqyCho8Gf.webp",quote: "'தூங்கும் போதும் சம்பாதிக்கலாம்' என்பது உண்மைதான். இன்று காலையில் எழும்போது 5 புதிய High-Ticket Sales Notifications வந்திருந்தது."},
  {id: 6,name: "Bindhu Madhavan",role: "Prompt Committee",image: null,quote: "Tech என்றாலே பயம் என்ற நிலையில் இருந்து Tech-Enabled ஆக மாறிவிட்டேன். இங்கு கற்றுக்கொடுக்கப்படும் Free Tools மற்றும் Strategies ஒரு Game Changer."}
];

// FAQ data
const faqData=[
  {id: 1,question: "இந்த Free Sales Automation Webinar எப்போது நடக்கும்?",answer: "இது ஒரு 3-மணிநேர FREE LIVE Online Webinar. தினமும் மாலை 4:00 PM முதல் 7:00 PM IST வரை நடக்கும். நீங்கள் Register செய்தவுடன்,அடுத்த Session-க்கான Joining Link உங்கள் Email மற்றும் WhatsApp-க்கு அனுப்பப்படும்."},
  {id: 2,question: "இது உண்மையாகவே Free-ஆ?",answer: "ஆம்,இது 100% FREE! மறைமுக கட்டணங்கள் (Hidden costs) ஏதும் இல்லை. தொழில்முனைவோர் தங்கள் Business-ஐ Automate செய்து அடுத்த கட்டத்திற்கு செல்ல உதவுவதே எங்களின் நோக்கம்."},
  {id: 3,question: "இது Live Class-ஆ அல்லது Recorded Video-வா?",answer: "இது 100% LIVE! Abdul Hakkim A அவர்களே நேரில் வந்து WhatsApp & AI Systems பற்றி Step-by-step ஆக சொல்லித் தருவார். உங்கள் சந்தேகங்களை நேரலையில் கேட்டுத் தெரிந்து கொள்ளலாம்."},
  {id: 4,question: "எனக்கு Coding அல்லது Technical அறிவு தேவையா?",answer: "இல்லை. இந்த Webinar Tech தெரியாதவர்களுக்காகவே (Non-techies) வடிவமைக்கப்பட்டுள்ளது. Coding இல்லாமல் இலவச WhatsApp Tools மற்றும் AI-ஐ பயன்படுத்துவது எப்படி என்று கற்றுத்தருவோம்."},
  {id: 5,question: "என்னால் Live வர முடியவில்லை என்றால் Recording கிடைக்குமா?",answer: "இல்லை,Recording வழங்கப்படாது. நீங்கள் உடனடியாக Action எடுக்க வேண்டும் என்பதற்காகவே இது Live-ஆக நடக்கிறது. நாங்கள் தினமும் Session நடத்துவதால்,ஒருவேளை நீங்கள் Miss செய்தால் அடுத்த நாள் கலந்து கொள்ளலாம்."},
  {id: 6,question: "நான் ஒரு Small Business வைத்திருக்கிறேன்,இது எனக்கு செட் ஆகுமா?",answer: "கண்டிப்பாக! நீங்கள் Coach,Consultant,Freelancer அல்லது ஒரு சிறிய Agency வைத்திருந்தாலும்,இந்த Automation முறைகள் மூலம் தானாகவே (Autopilot) Leads மற்றும் Sales பெற முடியும்."},
  {id: 7,question: "Register செய்த பிறகு என்ன நடக்கும்?",answer: "உடனடியாக உங்களுக்கு ஒரு Confirmation Email மற்றும் WhatsApp Message வரும். அதில் அடுத்த Session-க்கான Joining Link மற்றும் Bonus தகவல்கள் இருக்கும்."},
  {id: 8,question: "எனக்கு சந்தேகம் இருந்தால் Support கிடைக்குமா?",answer: "நிச்சயமாக! உங்களுக்கு எங்கள் Community-ல் Lifetime Access கிடைக்கும். அங்கு உங்கள் சந்தேகங்களை கேட்டு Automation Set செய்ய உதவி பெறலாம்."},
  {id: 9,question: "நான் ஒன்றுக்கு மேற்பட்ட முறை கலந்து கொள்ளலாமா?",answer: "தாராளமாக! நாங்கள் தினமும் Session நடத்துவதால்,உங்கள் சந்தேகங்களைத் தீர்த்துக்கொள்ள நீங்கள் மீண்டும் மீண்டும் கலந்து கொள்ளலாம்."},
  {id: 10,question: "வேறேனும் சந்தேகம் உள்ளதா?",answer: "எப்போது வேண்டுமானாலும் எங்களுக்கு WhatsApp செய்யுங்கள் - உங்களுக்கு உதவ எங்கள் Team தயாராக உள்ளது. Email: support@yinguru.com"}
];

function App() {
  const [isFormModalOpen,setIsFormModalOpen]=useState(false);
  const [selectedVideo,setSelectedVideo]=useState(null);
  const [showSuccess,setShowSuccess]=useState(false);
  const [expandedFaq,setExpandedFaq]=useState(null);
  const [faqSearch,setFaqSearch]=useState('');
  const [searchTimeout,setSearchTimeout]=useState(null);
  const [selectedRoleFilter,setSelectedRoleFilter]=useState('all');
  const [expandedFeedback,setExpandedFeedback]=useState({});
  const [hasAutoPopupShown,setHasAutoPopupShown]=useState(false);
  const autoPopupTimeoutRef=useRef(null);
  const {workshopDetails}=useWorkshopSchedule();

  // Auto-popup after 10 seconds
  useEffect(()=> {
    if (!hasAutoPopupShown && !isFormModalOpen) {
      autoPopupTimeoutRef.current=setTimeout(()=> {
        setIsFormModalOpen(true);
        setHasAutoPopupShown(true);
        if (typeof fbq !=='undefined') {
          fbq('track','ViewContent',{
            content_name: 'Free Sales Automation Webinar - Christmas Auto Popup',
            content_category: 'Webinar',
            content_type: 'auto_popup',
            value: 0,
            currency: 'INR'
          });
        }
      },10000);
    }
    return ()=> {
      if (autoPopupTimeoutRef.current) {
        clearTimeout(autoPopupTimeoutRef.current);
      }
    };
  },[hasAutoPopupShown,isFormModalOpen]);

  // Keyboard handling
  useEffect(()=> {
    const handleKeyDown=(e)=> {
      if (e.key==='Escape') {
        setIsFormModalOpen(false);
        setSelectedVideo(null);
      }
    };
    if (isFormModalOpen || selectedVideo) {
      document.addEventListener('keydown',handleKeyDown);
      document.body.style.overflow='hidden';
    } else {
      document.body.style.overflow='unset';
    }
    return ()=> {
      document.removeEventListener('keydown',handleKeyDown);
      document.body.style.overflow='unset';
    };
  },[isFormModalOpen,selectedVideo]);

  const handleFaqSearch=useCallback((value)=> {
    setFaqSearch(value);
    if (searchTimeout) clearTimeout(searchTimeout);
    const newTimeout=setTimeout(()=> {},300);
    setSearchTimeout(newTimeout);
  },[searchTimeout]);

  const filteredFaqs=useMemo(()=> {
    if (!faqSearch.trim()) return faqData;
    return faqData.filter(faq=>
      faq.question.toLowerCase().includes(faqSearch.toLowerCase()) ||
      faq.answer.toLowerCase().includes(faqSearch.toLowerCase())
    );
  },[faqSearch]);

  const filteredFeedbacks=useMemo(()=> {
    if (selectedRoleFilter==='all') return clientFeedbacks;
    return clientFeedbacks.filter(feedback=>
      feedback.role.toLowerCase().includes(selectedRoleFilter.toLowerCase())
    );
  },[selectedRoleFilter]);

  const uniqueRoles=useMemo(()=>
    ['all',...new Set(clientFeedbacks.map(f=> f.role))]
  ,[]);

  const toggleFaq=(faqId)=> setExpandedFaq(expandedFaq===faqId ? null : faqId);

  const toggleFeedbackExpanded=(feedbackId)=>
    setExpandedFeedback(prev=> ({...prev,[feedbackId]: !prev[feedbackId]}));

  const handleManualModalOpen=()=> {
    if (autoPopupTimeoutRef.current) {
      clearTimeout(autoPopupTimeoutRef.current);
      autoPopupTimeoutRef.current=null;
    }
    setHasAutoPopupShown(true);
    setIsFormModalOpen(true);
  };

  const handleFormSuccess=()=> {
    setShowSuccess(true);
    setTimeout(()=> setShowSuccess(false),3000);
  };

  const getInitials=(name)=>
    name.split(' ').map(word=> word[0]).join('').toUpperCase().slice(0,2);

  return (
    <div className="app">
      <AnimatePresence>
        {showSuccess && (
          <motion.div
            className="success-toast"
            initial={{opacity: 0,y: -50}}
            animate={{opacity: 1,y: 0}}
            exit={{opacity: 0,y: -50}}
          >
            <FiCheck className="success-icon" />
            Registration successful! Redirecting to thank you page...
          </motion.div>
        )}
      </AnimatePresence>

      <HeroSection openRegistration={handleManualModalOpen} />

      {/* Problem Section */}
      <motion.section
        className="problem-section"
        initial={{opacity: 0}}
        whileInView={{opacity: 1}}
        viewport={{once: true}}
        transition={{duration: 0.8}}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6}}
            >
              😰 இப்போ உங்கள் Business-ல் நீங்கள் இந்த கஷ்டங்களை அனுபவிக்கிறீர்களா?
            </motion.h2>

            <motion.div
              className="problem-intro"
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.1}}
            >
              <p>உங்கள் Business-ல் பெரிய கனவுகள் இருக்கலாம்,ஆனால் எதார்த்தத்தில் (Reality) தினமும் போராட வேண்டியுள்ளதா? நீங்கள் கடுமையாக உழைத்தாலும்,அதற்கான Results கிடைக்கவில்லையா?</p>
            </motion.div>

            <div className="problem-grid">
              {[
                {emoji: "🚀",title: "எங்கே தொடங்குவது என்று தெரியவில்லையா?",desc: "ஒரு Online Business ஆரம்பித்து வருமானம் ஈட்ட ஆசை,ஆனால் முதல் Step என்ன என்று தெரியவில்லையா? தகவல்கள் (Information Overload) உங்களை குழப்புகிறதா?"},
                {emoji: "📉",title: "Clients கிடைப்பது கஷ்டமாக உள்ளதா?",desc: "தொடர்ந்து Clients கிடைப்பது சவாலாக உள்ளதா? நீங்கள் Leads-ஐ துரத்தி (Chase) களைத்துவிட்டீர்கள்,ஆனால் Sales மட்டும் நடப்பதில்லை."},
                {emoji: "😫",title: "அதிக Stress & Tension?",desc: "Freedom தேடி Business ஆரம்பித்தீர்கள்,ஆனால் இப்போது 24/7 வேலை செய்து,Stress மற்றும் Burnout ஆகிவிட்டீர்களா?"},
                {emoji: "💸",title: "பணக்கஷ்டம் & Inconsistent Income?",desc: "மாதா மாதம் வருமானம் வருமா வராதா என்ற பயம் உள்ளதா? இந்த 'Feast or Famine' சுழற்சி உங்களை தூங்கவிடாமல் செய்கிறதா?"},
                {emoji: "🤯",title: "Technical விஷயங்கள் குழப்பமா?",desc: "AI,Funnels,Automation... இதெல்லாம் கேட்பதற்கு நன்றாக இருக்கிறது,ஆனால் செயல்படுத்துவது (Implementation) கடினமாக உள்ளதா?"},
                {emoji: "👻",title: "காணாமல் போகும் Business?",desc: "கடுமையான போட்டி (Competition) காரணமாக உங்கள் Business மக்களிடம் சென்றடையவில்லையா? Competitors வளர்கிறார்கள்,நீங்கள் தேங்கி நிற்கிறீர்களா?"},
                {emoji: "💔",title: "Follow-up செய்வது கடினமா?",desc: "Clients-ஐ தொடர்ந்து Follow-up செய்வது உங்கள் நேரத்தை தின்கிறதா? Manual Follow-ups உங்கள் ஆற்றலை (Energy) உறிஞ்சுகிறதா?"}
              ].map((problem,index)=> (
                <motion.div
                  key={index}
                  className="problem-card"
                  initial={{opacity: 0,y: 30}}
                  whileInView={{opacity: 1,y: 0}}
                  viewport={{once: true}}
                  transition={{duration: 0.6,delay: index * 0.1}}
                  whileHover={{y: -8,transition: {duration: 0.2}}}
                >
                  <h3>{problem.emoji} {problem.title}</h3>
                  <p>{problem.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </motion.section>

      {/* Solution Section */}
      <motion.section
        className="solution-section"
        initial={{opacity: 0}}
        whileInView={{opacity: 1}}
        viewport={{once: true}}
        transition={{duration: 0.8}}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6}}
            >
              🎯 இதற்கு ஒரே தீர்வு: Sales Automation மூலம் Unlimited Leads & Sales!
            </motion.h2>

            <motion.div
              className="solution-intro"
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.1}}
            >
              <p>தினமும் காலையில் எழும்போதே புது Sales Notifications வந்திருப்பதை யோசித்துப் பாருங்கள். இது Magic இல்லை—இதுதான் <strong>Sales Automation</strong>. இலவச <strong>WhatsApp & AI Funnels</strong> மூலம் நீங்கள் தூங்கும் போதும் வருமானம் ஈட்டுவது எப்படி என்று நாங்கள் கற்றுத்தருகிறோம்.</p>
            </motion.div>

            <div className="comparison-table">
              <motion.div
                className="old-way"
                initial={{opacity: 0,x: -30}}
                whileInView={{opacity: 1,x: 0}}
                viewport={{once: true}}
                transition={{duration: 0.6,delay: 0.2}}
              >
                <h3>❌ பழைய கஷ்டமான முறை (The Old Struggle)</h3>
                <ul>
                  <li>ஒவ்வொரு DM-க்கும் Manually Reply செய்வது</li>
                  <li>பதில் சொல்லாத Leads-ஐ துரத்துவது (Chasing)</li>
                  <li>நிலையற்ற மாத வருமானம் (Inconsistent Income)</li>
                  <li>Paid Ads மற்றும் Tech பார்த்து பயம்</li>
                  <li>Weekend-ல் கூட வேலை செய்வது</li>
                  <li>Market-ல் யாருக்கும் தெரியாமல் இருப்பது</li>
                </ul>
              </motion.div>

              <motion.div
                className="new-way"
                initial={{opacity: 0,x: 30}}
                whileInView={{opacity: 1,x: 0}}
                viewport={{once: true}}
                transition={{duration: 0.6,delay: 0.4}}
              >
                <h3>✅ Smart-ஆன Automation முறை</h3>
                <ul>
                  <li>Autopilot-ல் <strong>Unlimited Quality Leads</strong></li>
                  <li>நீங்கள் <strong>தூங்கும் போதும் Sales (Sales While You Sleep)</strong></li>
                  <li><strong>FREE WhatsApp Tools</strong> பயன்படுத்துவது</li>
                  <li>AI உங்களுக்காக Follow-up செய்யும்</li>
                  <li>கணிிக்கக்கூடிய வளர்ச்சி (Predictable Growth)</li>
                  <li>குடும்பத்தோடு செலவிட அதிக நேரம்</li>
                </ul>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </motion.section>

      {/* Discovery Section */}
      <motion.section
        className="discovery-section"
        initial={{opacity: 0}}
        whileInView={{opacity: 1}}
        viewport={{once: true}}
        transition={{duration: 0.8}}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6}}
            >
              🚀 இந்த FREE Webinar-ல் நீங்கள் என்ன கற்றுக்கொள்வீர்கள்?
            </motion.h2>

            <motion.div
              className="discovery-intro"
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.1}}
            >
              <p>இனியும் பணத்திற்காக நேரத்தை செலவிடாதீர்கள். உங்கள் Business வளர்ச்சியை முற்றிலும் இலவசமாக (FREE) Automate செய்யும் முறையை கற்றுக்கொள்ளுங்கள்.</p>
            </motion.div>

            <div className="discovery-grid">
              {[
                {icon: "🤖",title: "AI & WhatsApp Funnels",desc: "Coding எதுவும் இல்லாமல்,இலவச WhatsApp Tools மற்றும் AI-ஐ பயன்படுத்தி உங்களுக்கான Sales Funnel-ஐ அமைப்பது எப்படி?"},
                {icon: "😴",title: "Sales While You Sleep",desc: "நீங்கள் ஓய்வெடுக்கும் போதும் உங்கள் Business 24/7 இயங்கி,Sales-ஐ கொண்டு வரும் Secret Framework."},
                {icon: "📈",title: "Unlimited Quality Leads",desc: "Leads-ஐ தேடி அலையாமல்,High-paying Clients-ஐ உங்களை தேடி வர வைப்பது எப்படி?"},
                {icon: "💰",title: "Zero Cost Automation",desc: "விலையுயர்ந்த Software தேவையில்லை. உங்களிடம் ஏற்கனவே உள்ள Tools-ஐ வைத்தே இலவசமாக Automate செய்வது எப்படி?"},
                {icon: "⚡",title: "Instant Implementation",desc: "Webinar முடிவதற்குள் நீங்கள் செயல்படுத்தக்கூடிய Actionable Steps."}
              ].map((item,index)=> (
                <motion.div
                  key={index}
                  className="discovery-item"
                  initial={{opacity: 0,y: 30}}
                  whileInView={{opacity: 1,y: 0}}
                  viewport={{once: true}}
                  transition={{duration: 0.6,delay: index * 0.1}}
                  whileHover={{y: -8,scale: 1.02}}
                >
                  <div className="discovery-icon">{item.icon}</div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </motion.section>

      {/* Mentor Section */}
      <section className="mentor-section">
        <div className="container">
          <motion.div
            className="mentor-content"
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.6}}
            viewport={{once: true}}
          >
            <div className="mentor-image-container">
              <motion.img
                src="https://storage.files-vault.com/uploads/1761032692-VSdwsp8AG0.png"
                alt="Abdul Hakkim A - Sales Automation Expert"
                loading="lazy"
                whileHover={{scale: 1.02}}
                transition={{duration: 0.3}}
              />
            </div>

            <div className="mentor-info">
              <motion.h2
                initial={{opacity: 0,y: 20}}
                whileInView={{opacity: 1,y: 0}}
                viewport={{once: true}}
                transition={{duration: 0.6}}
              >
                🎯 Meet Abdul Hakkim A
              </motion.h2>

              <motion.p
                className="mentor-intro"
                initial={{opacity: 0,y: 20}}
                whileInView={{opacity: 1,y: 0}}
                viewport={{once: true}}
                transition={{duration: 0.6,delay: 0.1}}
              >
                Abdul Hakkim A ஒரு Sales Automation Expert. இவர் நூற்றுக்கணக்கான தொழில்முனைவோர்களை (Entrepreneurs) Manual வேலைகளில் இருந்து விடுவித்து,Automation பக்கம் மாற்றியுள்ளார். இவர் தினமும் இலவசமாக Webinar நடத்துகிறார்.
              </motion.p>

              <motion.div
                className="achievements"
                initial={{opacity: 0}}
                whileInView={{opacity: 1}}
                viewport={{once: true}}
                transition={{duration: 0.6,delay: 0.2}}
              >
                {[
                  {emoji: "🎯",title: "எங்களின் நோக்கம் (Mission):",desc: "நீங்கள் 24/7 உழைப்பதை நிறுத்திவிட்டு,தூங்கும் போதும் வருமானம் ஈட்ட உதவுவது."},
                  {emoji: "✅",title: "எங்களின் Strategy:",desc: "இலவச WhatsApp & AI Tools மூலம் உங்கள் முழு Sales Process-ஐயும் Automate செய்வது."},
                  {emoji: "📈",title: "கிடைக்கும் முடிவு (Result):",desc: "நிலையான வருமானம்,குறைவான Stress,மற்றும் நீங்கள் இல்லாமலேயே வளரும் Business."}
                ].map((item,index)=> (
                  <motion.div
                    key={index}
                    className="achievement"
                    initial={{opacity: 0,x: -20}}
                    whileInView={{opacity: 1,x: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.4,delay: 0.3 + index * 0.1}}
                  >
                    <span style={{fontSize: '1.5rem'}}>{item.emoji}</span>
                    <div>
                      <strong>{item.title}</strong>
                      <div style={{marginTop: '0.25rem'}}>{item.desc}</div>
                    </div>
                  </motion.div>
                ))}
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Video Testimonials Section */}
      <motion.section
        className="testimonials-section"
        initial={{opacity: 0}}
        whileInView={{opacity: 1}}
        viewport={{once: true}}
        transition={{duration: 0.8}}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6}}
            >
              🎬 Success Stories - Video Testimonials
            </motion.h2>

            <motion.p
              className="testimonials-subtitle"
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.1}}
            >
              மற்றவர்கள் எப்படி Autopilot மூலம் Sales செய்கிறார்கள் என்று பாருங்கள்
            </motion.p>

            <div className="video-grid">
              {testimonialVideos.map((video,index)=> (
                <motion.div
                  key={video.id}
                  className="video-card"
                  onClick={()=> {
                    setSelectedVideo(video);
                    if (typeof fbq !=='undefined') {
                      fbq('track','ViewContent',{
                        content_name: video.title,
                        content_type: 'video'
                      });
                    }
                  }}
                  initial={{opacity: 0,y: 30}}
                  whileInView={{opacity: 1,y: 0}}
                  viewport={{once: true}}
                  transition={{duration: 0.6,delay: index * 0.1}}
                  whileHover={{scale: 1.02,y: -8}}
                  whileTap={{scale: 0.98}}
                  tabIndex={0}
                  role="button"
                  aria-label={`Play testimonial video from ${video.name}`}
                >
                  <div className="video-thumbnail">
                    <img
                      src={video.thumbnail}
                      alt={`${video.title} thumbnail`}
                      loading="lazy"
                      width="300"
                      height="200"
                    />
                    <div className="play-overlay">
                      <FiPlay className="play-icon" />
                    </div>
                  </div>
                  <div className="video-info">
                    <h4>{video.title}</h4>
                    <p>{video.name}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </motion.section>

      {/* Client Feedback Section */}
      <motion.section
        className="client-feedback-section"
        initial={{opacity: 0}}
        whileInView={{opacity: 1}}
        viewport={{once: true}}
        transition={{duration: 0.8}}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6}}
            >
              எங்களிடம் படித்தவர்களின் கருத்துக்கள்
            </motion.h2>

            <motion.p
              className="feedback-subtitle"
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.1}}
            >
              நேரத்தை வீணடிப்பதை நிறுத்திவிட்டு,Sales-ஐ Automate செய்த தொழில்முனைவோர்களின் உண்மையான வெற்றிக் கதைகள்
            </motion.p>

            <motion.div
              className="feedback-filter"
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.2}}
            >
              <FiFilter className="filter-icon" />
              <select
                value={selectedRoleFilter}
                onChange={(e)=> setSelectedRoleFilter(e.target.value)}
                className="role-filter-select"
                aria-label="Filter by role"
              >
                {uniqueRoles.map(role=> (
                  <option key={role} value={role}>
                    {role==='all' ? 'All Roles' : role}
                  </option>
                ))}
              </select>
            </motion.div>

            <div className="feedback-grid">
              {filteredFeedbacks.map((feedback,index)=> (
                <motion.div
                  key={feedback.id}
                  className="feedback-card"
                  initial={{opacity: 0,y: 30}}
                  whileInView={{opacity: 1,y: 0}}
                  viewport={{once: true}}
                  transition={{duration: 0.6,delay: index * 0.1}}
                  whileHover={{scale: 1.02,y: -8}}
                  whileTap={{scale: 0.98}}
                  tabIndex={0}
                  role="article"
                  aria-labelledby={`feedback-name-${feedback.id}`}
                >
                  <div className="feedback-image-container">
                    {feedback.image ? (
                      <img
                        src={feedback.image}
                        alt={`${feedback.name} - ${feedback.role}`}
                        loading="lazy"
                        width="300"
                        height="200"
                        className="feedback-rect-image"
                        onError={(e)=> {
                          e.target.style.display='none';
                          e.target.nextSibling.style.display='flex';
                        }}
                      />
                    ) : null}
                    <div className="avatar-fallback-rect">
                      {getInitials(feedback.name)}
                    </div>
                  </div>

                  <div className="feedback-info">
                    <h3 id={`feedback-name-${feedback.id}`}>{feedback.name}</h3>
                    <p className="feedback-role">{feedback.role}</p>
                  </div>

                  <div className="feedback-quote">
                    <p>
                      {expandedFeedback[feedback.id] || feedback.quote.length <=140
                        ? feedback.quote
                        : `${feedback.quote.slice(0,140)}...`}
                    </p>
                    {feedback.quote.length > 140 && (
                      <button
                        className="read-more-btn"
                        onClick={()=> toggleFeedbackExpanded(feedback.id)}
                        aria-expanded={!!expandedFeedback[feedback.id]}
                      >
                        {expandedFeedback[feedback.id] ? 'Read less' : 'Read more'}
                      </button>
                    )}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </motion.section>

      {/* Bonus Section */}
      <motion.section
        className="bonus-section"
        initial={{opacity: 0}}
        whileInView={{opacity: 1}}
        viewport={{once: true}}
        transition={{duration: 0.8}}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6}}
            >
              🎁 FREE Automation Bonus Vault (Worth ₹25,000)
            </motion.h2>

            <div className="bonus-grid">
              {[
                {img: "https://storage.files-vault.com/uploads/1760966854-BXbDBFXvqB.png",emoji: "🤖",title: "AI Tools Starter Pack",desc: "50+ சிறந்த AI Tools பட்டியல் மற்றும் English Tutorials (Worth ₹5,000)"},
                {img: "https://storage.files-vault.com/uploads/1760966871-XKw3XTHpgg.png",emoji: "📊",title: "Business Automation Templates",desc: "உடனடியாக பயன்படுத்தக்கூடிய Ready-to-use Automation Workflows (Worth ₹8,000)"},
                {img: "https://storage.files-vault.com/uploads/1760976790-fakmsXQpOV.png",emoji: "💬",title: "Private Community Access",desc: "Lifetime Access - மற்ற தொழில்முனைவோர்களுடன் இணைய ஒரு வாய்ப்பு (Worth ₹7,000)"},
                {img: "https://storage.files-vault.com/uploads/1760977051-dmxHkhczed.png",emoji: "📞",title: "1-on-1 Strategy Call",desc: "உங்கள் Business-க்கு AI-ஐ பயன்படுத்த தனிப்பட்ட 30-நிமிட ஆலோசனை (Worth ₹5,000)"}
              ].map((bonus,index)=> (
                <motion.div
                  key={index}
                  className="bonus-item"
                  initial={{opacity: 0,y: 30}}
                  whileInView={{opacity: 1,y: 0}}
                  viewport={{once: true}}
                  transition={{duration: 0.6,delay: index * 0.1}}
                  whileHover={{y: -8,scale: 1.02}}
                >
                  <img src={bonus.img} alt={bonus.title} className="bonus-image" />
                  <h3>{bonus.emoji} {bonus.title}</h3>
                  <p>{bonus.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </motion.section>

      {/* FAQ Section */}
      <motion.section
        className="faq-section"
        initial={{opacity: 0}}
        whileInView={{opacity: 1}}
        viewport={{once: true}}
        transition={{duration: 0.8}}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6}}
            >
              Frequently Asked Questions (கேள்வி பதில்கள்)
            </motion.h2>

            <motion.p
              className="faq-subtitle"
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.1}}
            >
              இந்த FREE Daily Webinar பற்றி உங்களுக்கு ஏதேனும் சந்தேகம் உள்ளதா?
            </motion.p>

            <motion.div
              className="faq-search"
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.2}}
            >
              <FiSearch className="search-icon" />
              <input
                type="text"
                placeholder="கேள்விகளைத் தேடவும்..."
                value={faqSearch}
                onChange={(e)=> handleFaqSearch(e.target.value)}
                className="search-input"
                aria-label="Search frequently asked questions"
              />
            </motion.div>

            <div className="faq-accordion">
              {filteredFaqs.map((faq,index)=> (
                <motion.div
                  key={faq.id}
                  className="faq-item"
                  initial={{opacity: 0,y: 20}}
                  whileInView={{opacity: 1,y: 0}}
                  viewport={{once: true}}
                  transition={{duration: 0.4,delay: index * 0.05}}
                >
                  <button
                    className="faq-question"
                    onClick={()=> toggleFaq(faq.id)}
                    aria-expanded={expandedFaq===faq.id}
                  >
                    <span>{faq.question}</span>
                    <FiChevronDown
                      className={`chevron-icon ${expandedFaq===faq.id ? 'expanded' : ''}`}
                    />
                  </button>
                  <AnimatePresence>
                    {expandedFaq===faq.id && (
                      <motion.div
                        className="faq-answer"
                        initial={{height: 0,opacity: 0}}
                        animate={{height: 'auto',opacity: 1}}
                        exit={{height: 0,opacity: 0}}
                        transition={{duration: 0.3}}
                      >
                        <div className="faq-answer-content">{faq.answer}</div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
            </div>

            {filteredFaqs.length===0 && (
              <motion.div
                className="faq-no-results"
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                transition={{duration: 0.3}}
              >
                <p>No questions found. வேறு வார்த்தைகளை பயன்படுத்தி தேடவும்.</p>
              </motion.div>
            )}
          </motion.div>
        </div>
      </motion.section>

      {/* Final CTA Section */}
      <motion.section
        className="final-cta"
        initial={{opacity: 0}}
        whileInView={{opacity: 1}}
        viewport={{once: true}}
        transition={{duration: 0.8}}
      >
        <div className="container">
          <motion.div className="cta-content">
            <motion.h2
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6}}
            >
              🔥 இந்த வாய்ப்பை தவறவிடாதீர்கள்! இன்றே FREE-ஆக கலந்து கொள்ளுங்கள்!
            </motion.h2>

            <motion.p
              className="cta-subtitle"
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.1}}
            >
              முழுவதும் இலவசம் (Completely FREE) • 50 இடங்கள் மட்டுமே உள்ளன!
            </motion.p>

            <WorkshopTimer className="large" />

            <motion.button
              className="cta-primary large"
              onClick={()=> {
                handleManualModalOpen();
                if (typeof fbq !=='undefined') {
                  fbq('track','InitiateCheckout',{
                    content_name: 'Free Sales Automation Webinar - Christmas Final CTA',
                    content_category: 'Webinar',
                    value: 0,
                    currency: 'INR'
                  });
                }
              }}
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.4}}
              whileHover={{scale: 1.05,y: -4}}
              whileTap={{scale: 0.95}}
            >
              🎄 Start FREE – Holiday Special 🎆
            </motion.button>

            <motion.div
              className="guarantee-text"
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.5}}
            >
              <FiCheck className="check-icon" />
              <span>100% FREE • Credit Card தேவையில்லை • No Hidden Costs</span>
            </motion.div>
          </motion.div>
        </div>
      </motion.section>

      {/* Registration Form Modal */}
      <AnimatePresence>
        {isFormModalOpen && (
          <RegistrationForm
            isOpen={isFormModalOpen}
            onClose={()=> setIsFormModalOpen(false)}
            onSuccess={handleFormSuccess}
          />
        )}
      </AnimatePresence>

      {/* Video Modal */}
      <AnimatePresence>
        {selectedVideo && (
          <motion.div
            className="video-modal-overlay"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            onClick={(e)=> {
              if (e.target===e.currentTarget) setSelectedVideo(null);
            }}
          >
            <motion.div
              className="video-modal-content"
              initial={{opacity: 0,scale: 0.8}}
              animate={{opacity: 1,scale: 1}}
              exit={{opacity: 0,scale: 0.8}}
            >
              <div className="video-modal-header">
                <h3>{selectedVideo.title}</h3>
                <button
                  className="close-button"
                  onClick={()=> setSelectedVideo(null)}
                  aria-label="Close video"
                >
                  <FiX />
                </button>
              </div>
              <div className="video-embed-container">
                <iframe
                  src={`https://www.youtube.com/embed/${selectedVideo.embedId}?autoplay=1&rel=0`}
                  title={selectedVideo.title}
                  allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
              <div className="video-fallback">
                <p>
                  Can't view the video?
                  <a
                    href={selectedVideo.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open on YouTube
                  </a>
                </p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <p>&copy;2025 Free Sales Automation Webinar. All rights reserved.</p>
            <p style={{fontSize: '0.8rem',opacity: '0.7',marginTop: '1rem'}}>
              This site is not part of the Facebook website or Facebook Inc. Additionally,this site is NOT endorsed by Facebook in any way. FACEBOOK is a trademark of FACEBOOK,Inc.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;